import * as React from 'react'
import { StoreProps } from '../../../../services/stores/casting.store'
import { I18nService } from '../../../../services/utils/i18n.service'
import { moment } from '../../../../services/utils/moment.service'
import { openableDateToWorkingDay, UnserializedMultiOpeningHours } from '../../../../services/utils/openables.service'
import { formatDurationFromHours } from '../../../../services/utils/utils.service'
import { getDayPickerDateLocale, StyledDayPicker } from '../../../shared/styled-day-picker.component'

const i18nScoped = new I18nService(require('./casting-end-date-picker.component.yml'))

export default class CastingEndDatePickerComponent extends React.Component<StoreProps, never> {
  private multiOpeningHoursUnsafeMidnight: UnserializedMultiOpeningHours & { reduced: true }

  private isDayDisabled (date: Date) {
    // when groups are enabled, workings days and openning hours are not relevant (group_session are the single source of truth)
    return !this.props.data.offeredService.enable_groups && !this.multiOpeningHoursUnsafeMidnight[openableDateToWorkingDay(date)].length
  }

  private setEndDate (endDate: Date | null) {
    const { store, data: { slots, offeredService } } = this.props
    const date = endDate ? moment(endDate).format('YYYY-MM-DD') : null
    store.setSlots(slots.map(slot => ({ ...slot, end_date: date })))
    if (endDate || !offeredService.enable_groups) store.nextFocus({ closeOnMobile: true })
  }

  render () {
    const { store, data: { offeredService, prescriber, slots } } = this.props
    if (!slots.length || !slots[0].start_date) return null
    
    this.multiOpeningHoursUnsafeMidnight = store.getMultiOpeningHours().multiOpeningHoursUnsafeMidnight
    const minEndDate = store.getMinRecurrenceEndDate()
    const maxEndDate = store.getMaxRecurrenceEndDate()
    const initialMonth = store.getFirstEnabledDateFrom(minEndDate.toDate(), at => this.isDayDisabled(at))
    const endDate = slots.length > 0 && slots[0].end_date ? moment(slots[0].end_date) : null
    const infoMessages = []

    if (prescriber && typeof store.getPrescriberRemainingFundedHours() === 'number') {
      infoMessages.push(i18nScoped.t('prescriber_fund_up_to_x_hours', {
        prescriber_name: prescriber.name,
        hours: formatDurationFromHours(store.getPrescriberRemainingFundedHours()),
        occurrences: store.simulateOccurrencesUpToMaxAllowedDuration(store.getPrescriberRemainingFundedHours(), { end_date: null }).length
      }))
    }

    if (prescriber && store.getPrescriberPrescriberCastingFundingEndDate()) {
      infoMessages.push(i18nScoped.t('prescriber_plans_ends_at', { date: store.getPrescriberPrescriberCastingFundingEndDate().format('ll') }))
    }

    return <React.Fragment>
      { infoMessages.length > 0 && <ul style={{ marginBottom: '1.5em' }}>{ infoMessages.map((msg, index) => <li key={ index }>{ msg }</li>) }</ul> }

      { !offeredService.enable_groups && <div className="inputRadio" style={{ marginBottom: '0.5em' }}>
        <input type="checkbox" id="no_end_date" onChange={ () => this.setEndDate(null) } checked={ endDate === null } />
        <label htmlFor="no_end_date">{ i18nScoped.t(maxEndDate ? 'until_max_end_date' : 'no_end_date') }</label>
      </div> }

      <StyledDayPicker
        mode='single'
        defaultMonth={ endDate?.toDate() || initialMonth }
        startMonth={ initialMonth }
        locale={ getDayPickerDateLocale() }
        selected={ endDate?.toDate() }
        disabled={ date => minEndDate.isAfter(date, 'day') || maxEndDate?.isBefore(date, 'day') || this.isDayDisabled(date) }
        onSelect={ day => this.setEndDate(day) } />
    </React.Fragment>
  }
}
